<template></template>

<script>
// 要解决的问题:
// 外部点击链接进入，params更新state的params
// 内部改变state, parmas更新，但是不能再次触发state的变化
//
export default {
  data() {
    return {
      routeName: null,
      localParams: {},
      enableParams: true //是否根据 localParams 的值更新 url 的 params
    };
  },
  created: function() {
    this.routeName = this.$route.name;
  },
  watch: {
    $route(to, from) {
      //其他页面的变化忽略
      if (this.$route.name !== this.routeName) {
        return;
      }
      this.urlToLocal();
      this.localToUrl(); //补充另外view的params参数
    },
    localParams: {
      handler(d) {
        this.localToUrl();
        //保存全局state params
        this.$store.commit("updateObject", {
          from: d,
          to: this.stateUrlParams
        });
      },
      deep: true
    }
  },
  activated: function() {
    this.urlToLocal();
    this.localToUrl();
  },

  mounted: function() {},
  methods: {
    urlToLocal() {
      const queryParams = JSON.parse(JSON.stringify(this.$route.query));
      const localParams = this.localParams;
      let hasDiff = false;
      for (let key in queryParams) {
        const val = queryParams[key];
        if (
          val !== null &&
          val !== undefined &&
          localParams[key] !== undefined &&
          val !== localParams[key]
        ) {
          localParams[key] = val;
          hasDiff = true;
        }
      }
      if (hasDiff) {
        // console.log(this.viewName, "url --> local");
      }
      return hasDiff;
    },

    localToUrl() {
      if (!this.enableParams) {
        return;
      }

      const queryParams = JSON.parse(JSON.stringify(this.$route.query));
      const localParams = this.localParams;
      let hasDiff = false;
      for (let key in localParams) {
        const val = localParams[key];
        if (val !== null && val !== undefined && val !== queryParams[key]) {
          queryParams[key] = val;
          hasDiff = true;
        }
      }
      //会引起 watch $route 的变化
      if (hasDiff) {
        // console.log(this.viewName, "local --> url");
        this.$router.push({
          query: queryParams
        });
      }
      return hasDiff;
    }
  },
  computed: {}
};
</script>


// WEBPACK FOOTER //
// Urlparams.vue?8ea8371a